import React, { useRef, useState } from 'react';
import './Contact.css'
import emailjs from '@emailjs/browser'
import {RiMessengerFill} from 'react-icons/ri'
import {FaDiscord} from 'react-icons/fa'
import {MdEmail} from 'react-icons/md'
import {BsFileEarmarkCheckFill} from 'react-icons/bs'
import styled from 'styled-components/macro'
import { Helmet } from 'react-helmet'

const Messenger = styled(RiMessengerFill)``
const Discord = styled(FaDiscord)``
const Email = styled(MdEmail)``
const Copy = styled(BsFileEarmarkCheckFill)``


const Contact = () => {
  const [showCopyIcon, setShowCopyIcon] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const form = useRef(null);

  const sendEmail = (e) => {
    e.preventDefault();
    setDisableButton(true);
    emailjs.sendForm('service_aj5np77', 'template_oy83b1x', form.current, 'a5CbggCnYX-0eYO5y')
      .then((result) => {
          console.log(result.text);
          alert("Message successfully sent!");
          form.current.reset();
      }, (error) => {
        alert("Something went wrong!");
          console.log(error.text);
      }).finally(() => {
        setDisableButton(false);
      });
  };

  const handleEmailClick = () => {
    const email = 'aliquam.studio.contact@gmail.com';
    navigator.clipboard.writeText(email);
    setShowCopyIcon(true);
    setTimeout(() => setShowCopyIcon(false), 1100);
  }
  

  return (
    <div className='contact-main-container'>
      <Helmet>
        <title>Aliquam - Contact</title>
      </Helmet>
      <h1>CONTACT US</h1>
      <div className='contact-container'>
       <div className='contact-media'>
        <h2>We'll get back to you ASAP.</h2>
        <label className='media'><a className='media-text' href='https://www.facebook.com/AliquamStudios/'><Messenger className='icon'/>Messenger</a></label>
        <label className='media'><a className='media-text' href='https://discord.gg/kjWhhsZ6KN'><Discord className='icon'/>Discord</a></label>
        <label className='media'><p className='media-text' onClick={handleEmailClick}><Email className='icon' /> E-mail {showCopyIcon && <Copy className='copy-icon' />}</p>
        </label>     
        <label><p>Join our discord for a faster reply.</p></label>
       </div>
       <form ref={form} onSubmit={sendEmail} className='contact'>
        <label placeholder="Name"><p>Name<strong>*</strong></p></label>
        <input type="text" placeholder="Your name" name="user_name" required />
        <label><p>Email<strong>*</strong></p></label>
        <input type="email" placeholder="Your@email.com" name="user_email" required />
        <label><p>Subject<strong>*</strong></p></label>
        <input type="text" placeholder="Business" name="subject" required />
        <label><p>Discord</p></label>
        <input type="text" placeholder="Discord#0000" name="discord" />
        <label><p>Message<strong>*</strong></p></label>
        <textarea name="message" placeholder="Message.."/>
        <input type="submit" disabled={disableButton} value={disableButton ? "Sending..." : "Send"} />
       </form>
      </div>
    </div>
  );
}


export default Contact